module.exports = __webpack_public_path__ + "static/undraw_authentication_fsn5-40b7dccf83bc7fbf5627eeccfd23568d.svg";